// @flow
import React from "react";

import styles from "./contentCarousel.module.scss";

type Props = {
  items: Array<any>
};

const ContentCarousel = ({ items }: Props) => {
  const itemCount = items.length;

  return (
    <div
      className={styles.base}
      style={{
        "--count": itemCount
      }}
    >
      <div className={styles.wrapper}>
        <div className={styles.itemWrapper}>
          {items.map((item) => (
            <div className={styles.item}>{item}</div>
          ))}
        </div>
        <div className={styles.itemWrapper} aria-hidden>
          {items.map((item) => (
            <div className={styles.item}>{item}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentCarousel;
